import React, { forwardRef } from 'react';

export const GridPageStripContent = forwardRef(({
    children,
    headerTitle = null,
    headerAction = null,
}, ref) => {
    return (
        <div ref={ref}
            className="grid-page-strip"
        >
            <div className="grid-page-strip__header">
                <div className="grid-page-strip__header-content">
                    <div className="grid-page-strip__header-title">
                        {headerTitle}
                    </div>

                    <div className="grid-page-strip__header-action">
                        {headerAction}
                    </div>
                </div>
            </div>

            <div className="grid-page-strip__content-wrap">
                <div className="grid-page-strip__content">
                    {children}
                </div>
            </div>
        </div>
    );
});

GridPageStripContent.displayName = 'GridPageStripContent';
